import { weeklyFeed } from "@/mocks/gua";
import SectionTitle from "./SectionTitle";

export default function Weekly() {
  return (
    <section id="weekly" className="bg-background-100 py-12 md:py-16">
      <div className="mx-auto flex w-full max-w-6xl flex-col gap-8 px-4 md:px-6">
        <div className="flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
          <SectionTitle
            eyebrow="本周瓜汇总"
            title="这一周最热的天，都在这里了"
            desc="每周一整理，把过去七天最出圈的瓜一次补齐，几分钟看完，社交不掉线。"
          />
          <span className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-accent-100 px-3 py-1.5 text-xs font-bold text-accent-800">
            <i className="ri-refresh-line" aria-hidden="true" />
            09.04 — 09.10 本周
          </span>
        </div>

        <ol className="flex flex-col gap-4">
          {weeklyFeed.map((item, i) => (
            <li key={item.id}>
              <article className="group flex flex-col gap-4 rounded-2xl bg-white p-4 transition-colors hover:bg-background-50 sm:flex-row sm:items-center">
                <div className="relative h-48 w-full overflow-hidden rounded-xl sm:h-32 sm:w-52">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="h-full w-full object-cover"
                  />
                  <span className="absolute left-2 top-2 rounded-full bg-white/90 px-2.5 py-0.5 text-[11px] font-bold text-primary-700">
                    #{String(i + 1).padStart(2, "0")}
                  </span>
                </div>
                <div className="flex flex-1 flex-col gap-2">
                  <div className="flex items-center gap-2">
                    <span className="whitespace-nowrap rounded-full bg-secondary-100 px-2.5 py-0.5 text-[11px] font-bold text-secondary-900">
                      {item.tag}
                    </span>
                    <span className="text-xs text-foreground-600">{item.date}</span>
                    <span className="hidden text-xs text-foreground-400 sm:inline">· {item.source}</span>
                  </div>
                  <h3 className="font-heading text-base font-black leading-snug text-foreground-900 md:text-lg">
                    {item.title}
                  </h3>
                  <p className="line-clamp-2 text-sm leading-relaxed text-foreground-600">{item.summary}</p>
                </div>
                <div className="flex shrink-0 items-center gap-3 self-end sm:flex-col sm:self-center">
                  <div className="flex flex-col items-end">
                    <span className="text-xs text-foreground-600">热度</span>
                    <span className="font-heading text-lg font-black text-primary-500">{item.hot}%</span>
                  </div>
                  <div className="h-1.5 w-20 overflow-hidden rounded-full bg-background-200 sm:w-28">
                    <div
                      className="h-full rounded-full bg-gradient-to-r from-secondary-400 to-primary-500"
                      style={{ width: `${item.hot}%` }}
                    />
                  </div>
                </div>
              </article>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}